import { Container } from '@dagensmat/carrot/Layout';
import { ordersBySettlement } from '_common/reducers/orders';
import OrderListHeading from './OrderListHeading';
import { OrderHistoryLink } from './OrderHistoryLink';

type SettlementContainerProps = {
  settlement: ReturnType<typeof ordersBySettlement>[number];
};

export const SettlementContainer = ({
  settlement: { key, settlement, orders }
}: SettlementContainerProps) => {
  return (
    <Container key={key} mb="xl">
      <OrderListHeading
        settlementNumber={key}
        attachmentUrl={settlement?.settlementAttachmentUrl}
      />
      {orders?.map(order => {
        return <OrderHistoryLink key={order._id} order={order} />;
      })}
    </Container>
  );
};
